import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useSuperIntl } from "../_";
import { useGlobalSetting } from "../GlobalSetting";
import { SimpleDeleter } from "../SimpleDeleter";
import { ProTable } from '@ant-design/pro-components';
import ColumnSetting from '@ant-design/pro-table/lib/components/ColumnSetting';
import { TableContext } from '@ant-design/pro-table/lib/Store/Provide';
import { useBoolean, useLocalStorageState } from 'ahooks';
import { Button, Divider } from 'antd';
import * as CryptoJS from 'crypto-js';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { SuperProTableFilter, SuperProTableSearcher } from '.';
import { SuperProTableExporter } from "./Exporter";
export var SuperProTable = function SuperProTable(properties) {
  var _globalSetting$superP2, _properties$columns, _properties$params, _globalSetting$superP4, _properties$toolbar$a, _properties$toolbar, _properties$toolbar$a2, _properties$toolbar2, _ref3;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    deleteTargets = _useState2[0],
    setDeleteTargets = _useState2[1];
  var _useBoolean = useBoolean(),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    filtering = _useBoolean2[0],
    filteringActions = _useBoolean2[1];
  var formActions = useRef();
  var _useGlobalSetting = useGlobalSetting(),
    _useGlobalSetting2 = _slicedToArray(_useGlobalSetting, 1),
    globalSetting = _useGlobalSetting2[0];
  var intl = useSuperIntl();
  var persistenceKey = "JiShuXin['Form']['".concat(CryptoJS.SHA1(JSON.stringify((properties.columns || []).map(function (column) {
    return column.dataIndex;
  }))).toString(CryptoJS.enc.Hex), "']");
  var _useLocalStorageState = useLocalStorageState("".concat(persistenceKey, "['itemsState']"), {
      listenStorageChange: true,
      defaultValue: {}
    }),
    _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 2),
    itemsState = _useLocalStorageState2[0],
    setItemsState = _useLocalStorageState2[1];
  var tableActions = useRef();
  var _useState3 = useState(Object.create(null)),
    _useState4 = _slicedToArray(_useState3, 2),
    pageInfo = _useState4[0],
    setPageInfo = _useState4[1];
  var _ref = useLocalStorageState("".concat(persistenceKey, "['itemsValue']"), {
      listenStorageChange: true,
      defaultValue: {
        searcher: []
      }
    }),
    _ref2 = _slicedToArray(_ref, 2),
    parameters = _ref2[0],
    setParameters = _ref2[1];
  var setParametersUniquely = function setParametersUniquely(singleSearcher) {
    return setParameters(function (parameters0) {
      return _objectSpread(_objectSpread({}, parameters0), {}, {
        searcher: [].concat(_toConsumableArray((parameters0.searcher || []).filter(function (otherSingleSearcher) {
          return singleSearcher.key !== otherSingleSearcher.key;
        })), [singleSearcher])
      });
    });
  };
  var clearSearcher = function clearSearcher() {
    return setParameters(function (parameters0) {
      return _objectSpread(_objectSpread({}, parameters0), {}, {
        searcher: []
      });
    });
  };
  useEffect(function () {
    // -
    var waiter = setInterval(function () {
      if (formActions.current) {
        var _parameters$searcher;
        // -
        formActions.current.setFieldsValue((_parameters$searcher = parameters.searcher) === null || _parameters$searcher === void 0 ? void 0 : _parameters$searcher.reduce(function (previousValue, currentValue) {
          return _objectSpread(_objectSpread({}, previousValue), {}, _defineProperty({}, currentValue.key, currentValue.operator === '[]' ? currentValue.value.split(',') : currentValue.value));
        }, {}));
        // -
        clearInterval(waiter);
      }
    }, Math.pow(2, 11));
    // -
    return function () {
      return clearInterval(waiter);
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProTable, _extends({
    rowKey: "uuid",
    onReset: clearSearcher,
    beforeSearchSubmit: function beforeSearchSubmit(params) {
      var _globalSetting$superP;
      if ((_globalSetting$superP = globalSetting.superProTable) !== null && _globalSetting$superP !== void 0 && _globalSetting$superP.useLegacySearch) {
        // 清空原搜索条件
        clearSearcher();
        // -
        for (var parameterKey in params) {
          if (!['current', 'pageSize', '_timestamp'].includes(parameterKey)) {
            // -
            var parameterValue = params[parameterKey];
            // -
            if (parameterValue) {
              if (_.isArray(parameterValue)) {
                if (parameterValue.length > 0) {
                  setParametersUniquely({
                    key: parameterKey,
                    operator: '[]',
                    value: parameterValue.join(',')
                  });
                }
              } else {
                setParametersUniquely({
                  key: parameterKey,
                  operator: '≈',
                  value: String(parameterValue)
                });
              }
            }
          }
        }
        // -
        return {};
      } else {
        return params;
      }
    },
    polling: (_globalSetting$superP2 = globalSetting.superProTable) === null || _globalSetting$superP2 === void 0 ? void 0 : _globalSetting$superP2.automaticRefreshInterval,
    search: function (_globalSetting$superP3) {
      if ((_globalSetting$superP3 = globalSetting.superProTable) !== null && _globalSetting$superP3 !== void 0 && _globalSetting$superP3.useLegacySearch) {
        return _objectSpread(_objectSpread({}, globalSetting.superProTable.legacySearch), {}, {
          showHiddenNum: true,
          defaultFormItemsNumber: 6,
          submitterColSpanProps: {
            span: 16
          },
          layout: 'vertical',
          // labelWidth: 'auto',
          optionRender: function optionRender(_0, _1, defaultElements) {
            return [].concat(_toConsumableArray(defaultElements), [/*#__PURE__*/React.createElement(Divider, {
              key: "spliter0",
              type: "vertical",
              style: {
                marginRight: 0
              }
            }), /*#__PURE__*/React.createElement("div", {
              key: "columnSetter",
              className: "ant-pro-table-list-toolbar-setting-item"
            }, /*#__PURE__*/React.createElement(TableContext.Provider, {
              value: {
                sortKeyColumns: [],
                setSortKeyColumns: function setSortKeyColumns() {},
                columnsMap: itemsState,
                setColumnsMap: function setColumnsMap(columnsMap) {
                  if (columnsMap) {
                    setItemsState(_objectSpread(_objectSpread({}, itemsState), columnsMap));
                  } else {
                    setItemsState(undefined);
                  }
                },
                propsRef: {}
              }
            }, /*#__PURE__*/React.createElement(ColumnSetting, {
              showListItemOption: false,
              draggable: false,
              columns: _.uniqBy(properties.columns, 'dataIndex').filter(function (column) {
                return !!column.dataIndex;
              }).map(function (column) {
                return _objectSpread(_objectSpread({}, column), {}, {
                  key: column.dataIndex
                });
              })
            }))), /*#__PURE__*/React.createElement(Divider, {
              key: "spliter1",
              type: "vertical",
              style: {
                marginLeft: 0
              }
            })]);
          }
        });
      } else {
        return false;
      }
    }(),
    columnsState: {
      persistenceType: 'localStorage',
      persistenceKey: "".concat(persistenceKey, "['columnsState']").replace('Form', 'Table')
    }
  }, properties, {
    columns: (_properties$columns = properties.columns) === null || _properties$columns === void 0 ? void 0 : _properties$columns.map(function (column, columnIndex) {
      return _objectSpread(_objectSpread({}, column), {}, {
        hideInSearch: function () {
          if (column.hideInSearch) {
            return column.hideInSearch;
          } else {
            var _String$show, _String;
            return !((_String$show = (_String = itemsState[String(column.dataIndex)]) === null || _String === void 0 ? void 0 : _String.show) !== null && _String$show !== void 0 ? _String$show : true);
          }
        }()
      });
    }),
    formRef: formActions,
    actionRef: function actionRef(nullableTableActions) {
      if (nullableTableActions) {
        // -
        tableActions.current = nullableTableActions;
        // -
        if (properties.actionRef) {
          if (_.isFunction(properties.actionRef)) {
            properties.actionRef(nullableTableActions);
          } else {
            // @ts-ignore
            // noinspection JSConstantReassignment
            properties.actionRef.current = nullableTableActions;
          }
        }
      }
    },
    params: _objectSpread(_objectSpread(_objectSpread({}, parameters), properties.params), {}, {
      searcher: _.uniqBy(_.concat([], parameters.searcher, (_properties$params = properties.params) === null || _properties$params === void 0 ? void 0 : _properties$params.searcher), 'key').filter(function (chip) {
        return !!chip;
      })
    }),
    scroll: _objectSpread({
      x: 'max-content'
    }, properties.scroll),
    toolbar: {
      title: ((_globalSetting$superP4 = globalSetting.superProTable) === null || _globalSetting$superP4 === void 0 ? void 0 : _globalSetting$superP4.useLegacySearch) || /*#__PURE__*/React.createElement(SuperProTableSearcher, {
        columns: properties.columns || [],
        context: {
          filtering: [filteringActions],
          parameters: [parameters, setParameters]
        }
      }),
      actions: [].concat(_toConsumableArray((_properties$toolbar$a = (_properties$toolbar = properties.toolbar) === null || _properties$toolbar === void 0 ? void 0 : _properties$toolbar.actions) !== null && _properties$toolbar$a !== void 0 ? _properties$toolbar$a : []), [((_properties$toolbar$a2 = (_properties$toolbar2 = properties.toolbar) === null || _properties$toolbar2 === void 0 || (_properties$toolbar2 = _properties$toolbar2.actions) === null || _properties$toolbar2 === void 0 ? void 0 : _properties$toolbar2.length) !== null && _properties$toolbar$a2 !== void 0 ? _properties$toolbar$a2 : 0) > 0 && /*#__PURE__*/React.createElement(Divider, {
        key: "spliter0",
        type: "vertical"
      }), /*#__PURE__*/React.createElement(SuperProTableExporter, _extends({
        key: "export",
        context: {
          parameters: [_objectSpread(_objectSpread({}, parameters), pageInfo), setParameters]
        }
      }, properties)), /*#__PURE__*/React.createElement(Divider, {
        key: "spliter1",
        type: "vertical"
      })])
    },
    rowSelection: _objectSpread({}, properties.rowSelection),
    tableAlertOptionRender: function tableAlertOptionRender(properties0) {
      return [properties.tableAlertOptionRender && properties.tableAlertOptionRender(properties0), /*#__PURE__*/React.createElement(Button, {
        danger: true,
        type: "link",
        key: "batchDelete",
        onClick: function onClick() {
          return setDeleteTargets(properties0.selectedRows);
        }
      }, intl.formatMessage({
        id: 'Batch Delete'
      })), /*#__PURE__*/React.createElement(Button, {
        type: "link",
        key: "deselect",
        onClick: properties0.onCleanSelected
      }, intl.formatMessage({
        id: 'Deselect'
      }))];
    },
    pagination: _objectSpread(_objectSpread({
      defaultPageSize: 10,
      showQuickJumper: true,
      showSizeChanger: true
    }, properties.pagination), {}, {
      onShowSizeChange: function onShowSizeChange(current, pageSize) {
        return setPageInfo({
          current: current,
          pageSize: pageSize
        });
      }
    })
  })), /*#__PURE__*/React.createElement(SuperProTableFilter, {
    open: filtering,
    onOpenChange: filteringActions.set,
    columns: (_ref3 = properties.columns) !== null && _ref3 !== void 0 ? _ref3 : [],
    context: {
      parameters: [parameters, setParameters]
    }
  }), /*#__PURE__*/React.createElement(SimpleDeleter, {
    entities: deleteTargets,
    open: deleteTargets.length > 0,
    title: intl.formatMessage({
      id: 'Are you sure you want'
    }),
    onFinish: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var result, _tableActions$current, _tableActions$current2, _tableActions$current3;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!properties.onBatchDelete) {
              _context.next = 8;
              break;
            }
            _context.next = 3;
            return properties.onBatchDelete(deleteTargets);
          case 3:
            result = _context.sent;
            // -
            if (result) {
              // -
              (_tableActions$current = tableActions.current) === null || _tableActions$current === void 0 || _tableActions$current.reload();
              // -
              (_tableActions$current2 = tableActions.current) === null || _tableActions$current2 === void 0 || (_tableActions$current3 = _tableActions$current2.clearSelected) === null || _tableActions$current3 === void 0 || _tableActions$current3.call(_tableActions$current2);
            }
            // -
            return _context.abrupt("return", result);
          case 8:
            return _context.abrupt("return", Promise.resolve(true));
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })),
    onOpenChange: function onOpenChange(visible) {
      if (!visible) {
        setDeleteTargets([]);
      }
    }
  }));
};